export const siteSettings = {
  defaultLanguage: "en",
  site_header: {
    menu: [
      {
        id: 1,
        label: "Home",
        path: "/",
      },
      {
        id: 2,
        label: "Who We Are",
        path: "/who-we-are",
        subMenu: [
          {
            id: 1,
            label: "How it Started",
            path: "/who-we-are#how-it-started",
          },
          {
            id: 2,
            label: "Vision, Mission and Aims",
            path: "/who-we-are#vision-mission-and-aims",
          },
          // {
          //   id: 3,
          //   label: "Our Leadership",
          //   path: "/who-we-are#our-leadership",
          // },
          // {
          //   id: 4,
          //   label: "Our Board",
          //   path: "/who-we-are#our-board",
          // },
        ],
      },
      {
        id: 3,
        label: "What We Do",
        subMenu: [
          {
            id: 1,
            label: "Climate Resilience for Workers & Communities",
            path: "/global-climate-resilience-collective",
          },
          {
            id: 2,
            label: "Migrants Resilience Collaborative (MRC)",
            path: "https://www.migrantresilience.org/",
            external: true,
          },
          {
            id: 3,
            label: "Grassroots Leadership & Capacity",
            path: "/grassroots-leadership-and-capacity",
          },
          {
            id: 4,
            label: "Reports: Trends and Insights",
            path: "/#reports",
          },
        ],
      },
      {
        id: 4,
        label: "Where We Work",
        subMenu: [
          {
            id: 1,
            label: "Bangladesh",
            path: "/bangladesh",
          },
          {
            id: 2,
            label: "India",
            path: "/india",
          },
          {
            id: 3,
            label: "Indonesia",
            path: "/indonesia",
          },
          {
            id: 4,
            label: "Nepal",
            path: "/nepal",
          },
          {
            id: 5,
            label: "Philippines",
            path: "/philippines",
          },
        ],
      },
      {
        id: 4,
        label: "Events",
        subMenu: [
          {
            id: 0,
            label: "LCAW 2026",
            path: "https://lcaw-2026.peoplescourageinternational.org/",
          },
          {
            id: 1,
            label: "LCAW 2025",
            path: "https://lcaw.peoplescourageinternational.org/",
          },
          {
            id: 2,
            label: "AVPN 2025",
            path: "https://avpn.peoplescourageinternational.org",
          },
          {
            id: 3,
            label: "UNRBHR 2025",
            path: "https://unrbhr.peoplescourageinternational.org",
          },
        ],
      },
    ],
  },
};
